import { z } from 'zod';

const headerFooter = {
  zone: z.enum(['primary', 'first_page', 'even_pages']),
  section_index: z.number().int().nonnegative().safe().optional(),
};
/** Story addresses are local to Word; note indices come from a fresh get_footnotes read. */
export const WordFormattingPlaceSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('header'), ...headerFooter }).strict(),
  z.object({ kind: z.literal('footer'), ...headerFooter }).strict(),
  z.object({ kind: z.literal('footnote'), footnote_index: z.number().int().nonnegative().safe().optional() }).strict(),
]);
export type WordFormattingPlace = z.infer<typeof WordFormattingPlaceSchema>;
